import { render } from "./country-switcher.vue?vue&type=template&id=3e543c62"
import script from "./country-switcher.vue?vue&type=script&lang=js"
export * from "./country-switcher.vue?vue&type=script&lang=js"

import "./country-switcher.vue?vue&type=style&index=0&id=3e543c62&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__